var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05546 4.05546C3.57118 3.53973 4.27065 3.25 5 3.25H12C12.7293 3.25 13.4288 3.53973 13.9445 4.05546C14.4603 4.57118 14.75 5.27065 14.75 6V8C14.75 8.41421 14.4142 8.75 14 8.75C13.5858 8.75 13.25 8.41421 13.25 8V6C13.25 5.66848 13.1183 5.35054 12.8839 5.11612C12.6495 4.8817 12.3315 4.75 12 4.75H5C4.66848 4.75 4.35054 4.8817 4.11612 5.11612C3.8817 5.35054 3.75 5.66848 3.75 6V18C3.75 18.3315 3.8817 18.6495 4.11612 18.8839C4.35054 19.1183 4.66848 19.25 5 19.25H12C12.3315 19.25 12.6495 19.1183 12.8839 18.8839C13.1183 18.6495 13.25 18.3315 13.25 18V16C13.25 15.5858 13.5858 15.25 14 15.25C14.4142 15.25 14.75 15.5858 14.75 16V18C14.75 18.7293 14.4603 19.4288 13.9445 19.9445C13.4288 20.4603 12.7293 20.75 12 20.75H5C4.27065 20.75 3.57118 20.4603 3.05546 19.9445C2.53973 19.4288 2.25 18.7293 2.25 18V6C2.25 5.27065 2.53973 4.57118 3.05546 4.05546Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4695 8.46967C17.7624 8.17678 18.2373 8.17678 18.5301 8.46967L21.5301 11.4697C21.823 11.7626 21.823 12.2374 21.5301 12.5303L18.5301 15.5303C18.2373 15.8232 17.7624 15.8232 17.4695 15.5303C17.1766 15.2374 17.1766 14.7626 17.4695 14.4697L19.1892 12.75H6.99982C6.5856 12.75 6.24982 12.4142 6.24982 12C6.24982 11.5858 6.5856 11.25 6.99982 11.25H19.1892L17.4695 9.53033C17.1766 9.23744 17.1766 8.76256 17.4695 8.46967Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.570ec83c8f0478e9d33b52faa7f14689.svg";
export { ForwardRef as ReactComponent };